export default __webpack_public_path__ + "static/media/blue-select.99922017.png";